import { Link } from 'react-router-dom'
import { LanguageSwitcher } from '@/components/LanguageSwitcher'
import { useLocale } from '@/i18n/LocaleProvider'
import curlyLogo from '@/assets/brand/curly-logo.jpg'

export function Privacy() {
  const { t } = useLocale()
  return (
    <div className="mx-auto max-w-lg px-4 py-8">
      <div className="flex items-center gap-3">
        <img src={curlyLogo} alt="CURLY" className="brand-logo" />
        <div>
          <h1 className="text-lg font-semibold text-slate-100">{t('privacy.title')}</h1>
          <p className="text-sm text-slate-500">P2P Curly трекер</p>
        </div>
      </div>
      <LanguageSwitcher />
      <div className="mt-6 space-y-4 text-sm leading-6 text-slate-300">
        <p>{t('privacy.p1')}</p>
        <p>{t('privacy.p2')}</p>
        <p>{t('privacy.p3')}</p>
        <p>{t('privacy.p4')}</p>
      </div>
      <p className="mt-8">
        <Link to="/login" className="text-sm text-slate-200 underline">
          {t('privacy.back')}
        </Link>
      </p>
    </div>
  )
}
